export default __webpack_public_path__ + "static/media/Advanced-Care-Planning-2.c8b6b926.jpg";